import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/contexts'
import { ProfileType } from '@/enum/profile-type'

export function LayoutAdmin() {
  const { userProfiles } = useAuth()

  const isNotAdminOrSuperAdmin =
    !userProfiles?.includes(ProfileType.Admin) &&
    !userProfiles?.includes(ProfileType.SuperAdmin)

  if (isNotAdminOrSuperAdmin) {
    return <Navigate to="/not-allowed" replace />
  }

  return <Outlet />
}
